module.exports = __webpack_public_path__ + "static/media/developers-desktop.414e2e2a.jpg";